export type PrizmOverscrollMode = 'all' | 'scroll' | 'none';
